module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Polygon-7126e7cf5d349ee6799a7cb0f361cfc9.svg";